const content = {
  component: "PageTypeA",
  cssClass: "page-three",
  meta: {
    title: "Bringing trust and transparency to shipping",
    description:
      "Blockchain is transforming shipping, bringing efficiency and transparency to every party, from port to port.",
    og: {
      type: "website",
      title: "Blockchain simplifies shipping—learn how",
      description: `Shipping is a complex process. Forwarders, carriers, truckers, and customs agencies all need to work together seamlessly across multiple time zones. Blockchain is simplifying the process by providing a single, trusted digital platform that can align all parties and streamline the whole process.`,
      image: require("../../assets/images/social/trust-and-transparecy-1200x630.jpg")
    },
    twitter: {
      card: "summary",
      title:
        "Learn how blockchain enables shippers to wave goodbye to inefficiency",
      description: `CargoSmart is simplifying shipping. By using blockchain, the supply chain can be managed from a single platform, bringing transparency, security, and efficiency to a highly complex industry. `,
      site: "@Oracle",
      creator: "@Oracle",
      image: require("../../assets/images/social/trust-and-transparecy-300x300.jpg")
    }
  },
  title:
    "<span>Bringing Trust and </span><span>Transparency to Shipping</span>",
  heroImage: {
    preload: require("../../assets/images/bgs/trust-and-transparency-pre.jpg"),
    loaded: require("../../assets/images/bgs/trust-and-transparency.jpg"),
    mobile: require("../../assets/images/bgs/trust-and-transparency-mobile.jpg")
  },
  // * the heroImageOptions are currently only required and supported when using the PageTypeA component
  heroImageOptions: {
    default: {
      customPosition: [false]
    },
    mobile: {
      customPosition: [false]
    },
    limtedHeight: {
      customPosition: [false]
    }
  },
  sections: [
    {
      component: "SectionCopy",
      content: {
        copy: `With often more than 30 people and 200 documents involved in simply getting a shipment ready to sail from port, no wonder it takes time to bring all the relevant information together and errors are often made.  The end result?  Goods, ships and trucks in the wrong place, which causes delays and extra expense.`,
        type: "intro"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: null
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
        To simplify this complex supply chain process, CargoSmart Limited, a global shipping software solution provider, has developed a blockchain-based solution.  Its aim?  To make shipment information quickly, easily and reliably available to trusted parties accelerating the movement of goods.
        `,
        type: "default"
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: require("../../assets/images/svgs/ship.svg")
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>Shipping them is often the least expensive way of moving them over long distances. Without shipping, the import/export of affordable food and goods would not be possible.  One could almost say that shipping is the one industry which, more than any other, makes it possible for a truly global economy to work.</p>
          <p>What makes shipping so complex?  There are multiple parties involved, from shippers, forwarders, carriers, truckers, and customs agencies, often based in different countries, with different time zones, and with vastly different business systems.  They need to work together, often via complex, processes, and as the shipping industry is one of the oldest in the world, it tends to be slow on the technology adoption curve, often these are manual and paper driven.</p>
        `,
        type: "default"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          <p>CargoSmart is seeking to significantly change this and smooth the process, using Oracle Blockchain cloud service, the resulting solution will enable shipping transactions to be easily tracked and traced, helping bring more trust and transparency into the system.</p>
          <p>The CargoSmart initiative will provide a blockchain solution for shipment documentation to improve on the current, complex supply chain processes. It aims to provide the organisations involved with a trusted, digital platform for shipment documentation management enabling them to collaborate more efficiently and have a single, immutable version of truth.</p>
          <p>This can be referenced so that those involved can track and trace their cargo at each stage of its journey to check its progress and take immediate action should something untoward or unexpected happen, for example disruption from major weather systems, such as  Hurricane Florence and Super Cyclone Mangkhut.</p>
        `,
        type: "default",
        backgroundImage: require("../../assets/images/bgs/TrustAndTransparency_CargoSmart_bg.jpg")
      }
    },
    {
      component: "SectionSeperator",
      content: {
        image: require("../../assets/images/svgs/blockchain.svg")
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          The simplified the shipping documentation process will also boost efficiency by expediting documentation turnaround times and reducing disputes. The result is that everything becomes more agile, helping goods get to where they need to be, on time.
        `,
        type: "default"
      }
    },
    {
      component: "SectionQuote",
      content: {
        quote: `By helping us harness the many capabilities of Blockchain, we are able to move towards restoring trust and transparency in our supply chain network.  This will truly transform the shipping industry.`,
        author: `Lionel Louie`,
        position: `Chief Commercial Officer, CargoSmart`,
        type: "quote"
      }
    },
    {
      component: "SectionCopy",
      content: {
        copy: `
          Looking ahead, CargoSmart projects a 65% reduction in the amount of time required to collect, consolidate and confirm data from multiple parties and to handle shipping data that is repetitive in different documents by leveraging its blockchain shipment documentation solution.
        `,
        type: "default"
      }
    },
    {
      component: "SectionCallToAction",
      content: {
        title: `Transform your business with Oracle`,
        ctas: [
          {
            image: require("../../assets/images/svgs/report.svg"),
            copy: "Decision makers and technology report",
            url:
              "https://www.oracle.com/uk/area-of-interest/it/leading-technologies-survey.html?source=:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_IT_AW_HI_CM_UK_C33_Q33_RT&intcmp=:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_IT_AW_HI_CM_UK_C33_Q33_RT",
            buttonCopy: "Start your self-assessment"
          },
          {
            image: require("../../assets/images/svgs/servers.svg"),
            copy: "Try out Oracle Cloud Solutions",
            url:
              "https://cloud.oracle.com/tryit?source=:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_IT_CT_TR_CM_UK_C38_Q34_CL&intcmp=:ow:o:cs:mt:RC_EMMK181024P00070C0001:YTTFY19_IT_CT_TR_CM_UK_C38_Q34_CL",
            buttonCopy: "Take our Quick Tour"
          }
        ],
        type: "cta"
      }
    }
  ]
};

export default content;
